@if (!isArchiveTask) {
<div>
  <p [class]="getTimeLeftClass()">{{ getTimeLeft() }}</p>
  <p class="turnaround-time">({{ turnaroundTime }})</p>
</div>
}
